export const NekoColors = {
  black: '#000000',
  blackRGB: '0, 0, 0',
  blue: '#007cba',
  blueRGB: '0, 124, 186',
  deepBlue: '#134575',
  finderBorder: '#DEDEDE',
  lightBlue: '#EBF3FF',
  lightGray: '#cacaca',
  lightGray2: '#F5F5F5',
  lightPurple: '#D8B1FF',
  gray: '#E8E8E8',
  green: '#0EA480',
  darkGray: '#A0A0A0',
  disabledForm: '#828282',
  orange: '#daa827',
  overlay: 'rgba(16, 16, 16, 0.92)',
  red: '#ba4300',
  redHighlight: '#de5307',
  header: '#007cba',
  proGray: '#7F8EA0',
  progress: '#8414a8',
  purple: '#956DBE',
  tableGray: '#FAFAFA',
  yellow: '#e4b42b',
  yellowRGB: '224, 156, 54',
  white: '#ffffff',
  whiteRGB: '255, 255, 255',
}

export const NekoColorTheme = {
  danger: NekoColors.red,
  primary: NekoColors.blue,
  secondary: NekoColors.lightBlue,
  success: NekoColors.green,
}

const NekoTheme = {

  // COLORS
  ...NekoColors,
  ...NekoColorTheme,

  // FONT

  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell,"Helvetica Neue", sans-serif',
  fontSizeH1: '24px',
  fontSizeH2: '18px',
  fontSizeText: '13px',
  fontSizeSmall: '12px',
  fontSizeSmallButton: '10px',

  // SHADOW

  lightShadow: '0px 0px 10px rgba(0,0,0,0.1)',
};

export default NekoTheme;
